export default async (axios, searchValue, page, limit, params = {}) => {
    const response = await axios.get('/ImageSource/GetSourceLocationListing');

    const { data } = response;

    return {
        metadata: {
            page: 1,
            pages: 1,
        },
        result: data.map(item => ({
            label: item.label,
            key: item.id,
            item,
        })),
    };
};
